(function () {
 
  var FREE_THRESHOLD_CENTS = 10000;
  var SUB_THRESHOLD_GRAMS  = 1000;
 
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }
 
  function createBar() {
    var existing = document.getElementById('ri-shipping-bar');
    if (existing) return;
 
    var bar = document.createElement('div');
    bar.id = 'ri-shipping-bar';
    bar.className = 'ri-shipping-bar';
    bar.innerHTML =
      '<p id="ri-shipping-msg" class="ri-shipping-bar__msg"></p>' +
      '<div class="ri-shipping-bar__track">' +
        '<div id="ri-shipping-fill" class="ri-shipping-bar__fill" style="width:0%"></div>' +
      '</div>';
 
    var form = document.querySelector('.cart-drawer form, form.cart-drawer');
    var header = document.querySelector('.cart-drawer__header');
    if (header && header.parentNode) {
      header.parentNode.insertBefore(bar, header);
    } else if (form) {
      form.insertBefore(bar, form.firstChild);
    }
  }
 
  function updateBar(cart) {
    createBar();
 
    var bar  = document.getElementById('ri-shipping-bar');
    var msg  = document.getElementById('ri-shipping-msg');
    var fill = document.getElementById('ri-shipping-fill');
    if (!bar || !msg || !fill) return;
 
    var isSub = false;
    if (cart.items) {
      cart.items.forEach(function (item) {
        if (
          item.selling_plan_allocation ||
          (item.properties && (
            item.properties['shipping_interval_frequency'] ||
            item.properties['subscription_id']
          ))
        ) { isSub = true; }
      });
    }
 
    var pct, msgHtml, unlocked;
 
    if (isSub) {
      var weightG = cart.total_weight;
      var remainG = SUB_THRESHOLD_GRAMS - weightG;
      pct         = Math.min((weightG / SUB_THRESHOLD_GRAMS) * 100, 100);
      unlocked    = weightG >= SUB_THRESHOLD_GRAMS;
      if (unlocked) {
        msgHtml = 'Free urban shipping unlocked! Rural deliveries incur a $7.50 surcharge.';
      } else {
        var remainDisplay = remainG >= 1000
          ? (remainG / 1000).toFixed(1).replace(/\.0$/, '') + 'kg'
          : remainG + 'g';
        msgHtml = 'Add <strong>' + remainDisplay + ' more</strong> for free shipping';
      }
    } else {
      var total  = cart.total_price;
      var remain = FREE_THRESHOLD_CENTS - total;
      pct        = Math.min((total / FREE_THRESHOLD_CENTS) * 100, 100);
      unlocked   = total >= FREE_THRESHOLD_CENTS;
      if (unlocked) {
        msgHtml = 'Free urban shipping unlocked! Rural deliveries incur a $7.50 surcharge.';
      } else {
        msgHtml = 'You\'re <strong>' + formatMoney(remain) + '</strong> away from free urban shipping - rural surcharge of $7.50 applies.';
      }
    }
 
    fill.style.width = pct + '%';
    msg.innerHTML    = msgHtml;
 
    if (unlocked) {
      bar.classList.add('ri-shipping-bar--unlocked');
    } else {
      bar.classList.remove('ri-shipping-bar--unlocked');
    }
  }
 
  function fetchAndUpdate() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateBar(cart); })
      .catch(function (e) { console.warn('RI shipping bar:', e); });
  }
 
  document.addEventListener('cart:updated', fetchAndUpdate);
 
  document.addEventListener('click', function (e) {
    if (e.target.closest('[href="#cart"], .js-drawer-open-cart, [data-cart-toggle], .site-header__cart')) {
      setTimeout(fetchAndUpdate, 300);
    }
  });
 
  var drawer = document.querySelector('[data-section-type="cart-drawer"]');
  if (drawer) {
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'aria-hidden' && drawer.getAttribute('aria-hidden') === 'false') {
          setTimeout(fetchAndUpdate, 150);
        }
      });
    });
    observer.observe(drawer, { attributes: true });
  }
 
  fetchAndUpdate();
 
})();
 